<template>
  <div>
    <BlockUI v-if="loading"></BlockUI>
    <TituloComponent
      icono-titulo="fas fa-dollar-sign"
      texto-titulo="Listado de ventas"
      :to-create-action="{name:'NuevoPedido'}"
    ></TituloComponent>
    <div class="main-card mb-3 card col-12 col-md-8 offset-md-2">
      <div class="card-body">
        <DataList
          url="/movimientos"
          :fields="fields"
          :rowClick="ver"
          :toPesos="toPesos"
          :toDate="toDate"
           ref="datatable"
        ></DataList>
      </div>
    </div>
  </div>
</template>
<script>
import TituloComponent from "@/components/layouts/TituloComponent";
import BlockUI from "@/components/loaders/BlockUI";
import axios from 'axios';
import DataList from "@/components/layouts/DataList";
import Swal from "sweetalert2";
export default {
  name: "ListarVentas",
  components: {
    TituloComponent,
    DataList,
    BlockUI
  },
  data() {
    return {
      fields: [
        {
          name: "denominacion",
          label: "",
          type: "title",
          class: "text-alternate",
          append: " - "
        },
        {
          name: "total",
          label: "",
          type: "title",
          class: "text-success",
          prepend: "$"
        },
        {
          name: "cliente.nombre",
          label: "Cliente",
          type: "field",
          class: "text-info"
        },
        {
          name: "forma_pago",
          label: "Forma de pago",
          type: "field",
          class: ""
        },
        {
          name: "created_at",
          label: "Fecha",
          type: "field",
          class: ""
        },
        {
          name: "user.nombre",
          label: "Vendedor",
          type: "field",
          class: ""
        },
        {
          name: "impreso",
          type: "badge",
          trueText: "Impreso",
          trueClass: "badge badge-success ml-2",
          trueIcon: "fas fa-check mr-1",
        }
      ],
      toPesos: ["total"],
      toDate: ["created_at"],
      loading: false
    };
  },
  mounted() {},
  methods: {
    ver(movimiento) {
      if (movimiento.tipo != 'Venta') return;
      Swal.fire({
        title: movimiento.denominacion,
        text: movimiento.impreso ? 'Ya marcado como impreso' : '',
        showCancelButton: true,
        confirmButtonText: 'Imprimir',
        cancelButtonText: 'Marcar como impreso',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#28a745',
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          window.open(
            `${axios.defaults.baseURL}/imprimir/comprobante/${movimiento.id}`
          );
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          axios.patch(`/movimientos/${movimiento.id}/marcar-impreso`)
            .then(() => {
              Swal.fire('Listo', 'Comprobante marcado como impreso.', 'success');
            });
        }
      });
    }
  }
};
</script>